import React from 'react';
import styled from 'styled-components';
import { useImportStationTextStore } from '../../shared/store/importStationTextStore';
import { useProjectDetailState } from '../../shared/hooks/useApi/useProjectDetail';
import { useCanShowProjectDetail } from '../../shared/hooks/useProjectVisibility';
import { useTextBlock } from '../../shared/hooks/useApi/useTextBlock';
import { TextSimpleData } from '../../shared/dto/EntityRepository';
import SimpleText from './SimpleText';
import { getModalMessage } from '../../shared/constants/modalMessages';
import { getPageMessage } from '../../shared/constants/pageMessages';
import PageAboutTextImport from './PageAboutTextImport';

const ImportStationTextMain: React.FC = () => {
  const { simpleList } = useImportStationTextStore();
  const { project } = useProjectDetailState();
  const canShowProject = useCanShowProjectDetail();
  const { selectTextForImport } = useTextBlock();

  const onClickTextHandler = async (textId: string) => {
    await selectTextForImport(textId);
  };

  if (!canShowProject || !project) return null;

  return (
    <MainContainer>
      <ImportMainTitleWrapper>
        <ImportTitle>{getModalMessage('SELECT_TO_IMPORT_TEXT')}</ImportTitle>
      </ImportMainTitleWrapper>
      <ImportContentContainer>
        {simpleList.length === 0 ? (
          <NoContentContainer>
            {getPageMessage('IMPORT_STATION_EMPTY_TEXT')}
          </NoContentContainer>
        ) : (
          simpleList.map((sw) => (
            <SimpleContentComp key={sw.id}>
              <SimpleText data={sw as TextSimpleData} onClickHandler={onClickTextHandler} />
            </SimpleContentComp>
          ))
        )}
      </ImportContentContainer>
      <PageAboutTextImport />
    </MainContainer>
  );
};

const MainContainer = styled.div`
  width: 24vw;
  min-width: 260px;
  max-width: 260px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1.5vw;
`;

const ImportMainTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 1.5vh;
`;

const ImportTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  ${({ theme }) => theme.typography.Body_02_1};
`;

const ImportContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1vw;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const NoContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_03_2};
  white-space: pre-line;
`;

const SimpleContentComp = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export default ImportStationTextMain;
